import { useTranslation } from "react-i18next";
import { Form } from "semantic-ui-react";

import { useSelectedDealer } from "components";
import { createFormHelper } from "lib/Form";
import { ASTERISK_PLACEHOLDER } from "modules/DealerOverviewDashboard/components";
import "modules/DealerOverviewDashboard/components/Service/components/PlanIT/PlanIT.scss";

import type { DealerOverviewFormPayload } from "modules/DealerOverviewDashboard/hooks";

const FormHelper = createFormHelper<DealerOverviewFormPayload>();

export const PlanIT = () => {
  const { t } = useTranslation();
  const { watch, formState, setValue } = FormHelper.useFormContext();

  const { selectedDealer } = useSelectedDealer();

  const [isPlanitEnabled, planitUsername] = watch(["planit_planning_enabled", "planit_planning_user_name"]);
  const isPlanitValid = !isPlanitEnabled || planitUsername;
  const planitError = formState.isSubmitted && !isPlanitValid;

  const clearPlanitFields = (checked: boolean) => {
    if (checked) return;
    setValue("planit_planning_user_name", "");
    setValue("planit_planning_password", "");
  };

  return (
    <Form.Field width={8} className="PlanIT">
      <div className="dealer-overview-subheading">{t("v8_planit_settings", "PlanIT Settings")}</div>
      <FormHelper.Field.Checkbox name="planit_planning_enabled" label={t("v8_planit_planning_enabled", "Plan IT Planning enabled")} onChange={clearPlanitFields} />
      {isPlanitEnabled && (
        <>
          <Form.Field required error={planitError} className="planit-field">
            <label>{t("v8_planit_username", "Plan IT Username")}</label>
            <FormHelper.Field.Input name="planit_planning_user_name" preventAutofill />
          </Form.Field>
          <Form.Field className="planit-field">
            <label>{t("v8_planit_password", "Plan IT Password")}</label>
            <FormHelper.Field.Input
              name="planit_planning_password"
              preventAutofill
              inputProps={{ type: "password", placeholder: selectedDealer?.has_planit_planning_password ? ASTERISK_PLACEHOLDER : "" }}
            />
          </Form.Field>
        </>
      )}
    </Form.Field>
  );
};
